import debounce from 'lodash/debounce';
import proxyCallApp from './proxyCallApp';
import detector from './detector';

class Bridge {
    constructor() {
        Object.assign(this, detector.call(this));
    }

    register(fnName, process) {
        this[fnName] = debounce(params => {
            const req = process(params);
            if (!this.isApp) {
                if (req.fallback) {
                    req.fallback(params);
                    return Promise.resolve();
                }
                const errorData = {
                    return_code: -99,
                    return_error_msg: '非APP环境'
                };
                return Promise.reject(errorData);
            }
            if (req.appVersion && req.appVersion.split('.').join('') > this.appVersion.split('.').join('')) {
                const errorData = {
                    return_code: -250,
                    return_error_msg: '此功能不支持当前版本，请升级'
                };
                return Promise.reject(errorData);
            }
            return proxyCallApp.call(this, fnName, req.api);
        }, 300, {
            leading: true,
            trailing: false
        });
    }
}

export default new Bridge();
